import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	tags: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[4],
	},
	automationPrompt: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		padding: `${SPACE[4]}px ${SPACE[8]}px`,
		fontSize: THEME.typography.fontSizes.sm,
	},
	automationLine: {
		padding: `${SPACE[4]}px ${SPACE[12]}px`,
		color: THEME.colors.text.main,
	},
	automationName: {
		color: THEME.colors.primary.main,
	},
	automationButton: {
		margin: SPACE[8],
	},
});
